<template>
	<div v-if="media" class="c-file-media flex-center" @click="previewHandle">
		<video v-if="info.media == 'video'" :src="encodeSrc"></video>
		<img v-else-if="info.media == 'image'" :src="encodeSrc">
		<i v-else class="c-file-icon c-icon-file" :class="`c-icon-file-${info.suffix}`"></i>
	</div>
	<div v-else class="c-file flex-center-cross" @click="previewHandle">
		<div class="c-file-thum flex-center">
			<img v-if="info.media == 'image'" :src="encodeSrc" alt="">
			<i v-else class="c-icon-fw c-icon-file" :class="`tf-file-${info.suffix}`"></i>
		</div>
		<a class="ellipsis flex-grow">{{info.name}}{{info.suffix ? '.' : ''}}{{info.suffix}}</a>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import {cryptoJs} from '@deanwu/vue-component-library-mobile'

	export default {
		name: 'cFile',
		
		props: {
			src: String,
			media: Boolean,
			preview: {
				type: [Boolean, Array],
				default: true
			}
		},

		computed: {
			...mapState(['ENV']),

			docType() {
				return this.ENV == 'mp' ? [
					'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf'
				] : [
					'doc', 'dot', 'wps', 'wpt', 'docx', 'dotx', 'docm', 'dotm', 'rtf',
					'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps',
					'xls', 'xlt', 'et', 'xlsx', 'xltx', 'csv', 'xlsm', 'xltm',
					'pdf'
				]
			},

			info() {
				return this.parseFile(this.src);
			},

			encodeSrc() {
				return this.src.replaceAll(this.info.name, encodeURIComponent(this.info.name));
			},

			previewList() {
				return Array.isArray(this.preview) ? this.preview.filter(item => this.parseFile(item).media) : [];
			}
		},
		
		methods: {
			downloadHandle() {
				this.$compsConfig.config.file.openEvent(this.encodeSrc);
			},
			
			previewHandle() {
				if (!this.preview) {
					!this.media && this.downloadHandle();
					return;
				}
				if (this.info.media) {
					this.$preview({
						src: this.previewList.length ? this.previewList : this.encodeSrc,
						index: this.previewList.includes(this.src) ? this.previewList.indexOf(this.src) : 0
					});
				} else if (this.docType.includes(this.info.suffix.toLocaleLowerCase())) {
					if (this.ENV == 'mp') {
						this.mp.navigateTo('/pages/power', {
							power: 'openFile',
							data: encodeURIComponent(this.src)
						});
					} else {
						window.open(`/doc?url=${encodeURIComponent(cryptoJs.AES.encrypt(this.src, 'doc').toString())}`);
					}
				} else {
					this.downloadHandle();
				}
			}
		}
	}
</script>

<style lang="stylus">
	.c-upload-list > li {
		position: relative;

		&:nth-child(n+2) {
			margin-top: 4px;
		}
		
		> a {
			position: absolute;
			right: 0;
			top: 0;
			width: 1rem;
			height: 1rem;
			line-height: 1rem;
			font-size: 0 !important;
			text-align: center;
			color: #999;

			&:before {
				content: '\e627';
				font-family: 'iconfont';
				font-size: .32rem;
			}
		}

		.c-file {
			padding-right: 1rem;
		}
	}
</style>

<style lang="stylus" scoped>
	.c-file {
		gap: .26rem;
		width: 100%;
		height: 1rem;
		padding: 0 .14rem;
		background: #F9F9F9;
		
		&-media {
			box-sizing: border-box;
			width: 1.6rem;
			height: 1.6rem;
			border: .02rem solid var(--unit-border);
			overflow: hidden;
			background: #fff;
			
			video {
				width: 100%;
				height: 100%;
				background: #000;
			}
		}
		
		&-icon {
			font-size: .36rem;
		}
		
		&-thum {
			width: .8rem;
			height: .8rem;
			font-size: .56rem;
		}
		
		a {
			line-height: .3rem;
			font-size: .26rem;
		}
	}
</style>
